import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { SearchField } from '@statsbomb/kitbag-components';
import useTypingState from '../../utils/hooks/useTypingState';
import { ERROR_CODES } from '../../utils/errorCodes/errorCodes';
import { StyledLocalSearch } from './LocalSearch.styles';
import { SEARCH_METADATA_PARAM } from './searchMetadataWithParam';
import LocalSearchResults from './LocalSearchResults';

const LocalSearch = ({ handleResult, filterResultIds }) => {
  const [isTyping, setIsTyping, searchString, setSearchValue] =
    useTypingState();
  const [isResultsOpen, setIsResultsOpen] = useState(false);

  const {
    data: searchData,
    loading: isLoading,
    error: searchError,
  } = useQuery(SEARCH_METADATA_PARAM, {
    skip: isTyping,
    variables: {
      searchString,
    },
    headers: {
      'Accept-Version': 'v2023q2',
    },
  });

  if (searchError) {
    console.error(ERROR_CODES.SEARCH_METADATA, searchError);
  }

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setIsTyping(true);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    setIsTyping(false);
  };

  // filter IDs from the search results
  const parsedSearch = searchData?.searchMetadata.filter(
    (obj) => !filterResultIds.includes(obj.id)
  );

  return (
    <StyledLocalSearch>
      <SearchField
        value={searchString}
        isLoading={isLoading}
        onChange={handleSearch}
        onClear={handleClearSearch}
        onClick={() => setIsResultsOpen(true)}
        placeholder="Search..."
        searchIconTitle="search"
        testId="local-search-input"
      />
      {isResultsOpen && searchData?.searchMetadata.length > 0 && (
        <LocalSearchResults
          results={parsedSearch}
          handleResult={handleResult}
        />
      )}
    </StyledLocalSearch>
  );
};

LocalSearch.propTypes = {
  handleResult: PropTypes.func,
  // fitler these IDs out of the search results
  filterResultIds: PropTypes.arrayOf(PropTypes.number),
};

LocalSearch.defaultProps = {
  handleResult: () => {},
  filterResultIds: [],
};

export default LocalSearch;
